import { useFieldArray, useFormContext } from 'react-hook-form';

import { AutoCompleteInput } from '@components/ui/autocomplete/auto-complete-input';

import { useGetProductsWithVariationsQuery } from '@/features/slice/products/product/productApiSlice';
import { useUrlFilter } from '@/hooks';

import { useCreateStockAdjustmentContext } from './context';
import { CreateStockAdjustment } from './schema';

export const ProductSelector = () => {
    const { setSearchText, debouncedSearchText } = useUrlFilter();

    const {
        setSelectedProductId,
        setSelectedProductName,
        getBatchesByProductVariationId,
    } = useCreateStockAdjustmentContext();

    const { data, isLoading, isFetching } = useGetProductsWithVariationsQuery({
        search: debouncedSearchText,
    });

    const handleSearchTextChange = (value: string) => {
        setSearchText(value);
    };

    const { reset, setValue, control } =
        useFormContext<CreateStockAdjustment>();

    const { append } = useFieldArray({
        control,
        name: 'items',
    });

    const handleSelectedProductChange = async (
        productVariationId: string,
        name: string,
    ) => {
        if (!productVariationId || !name) {
            setSelectedProductId(null);
            setSelectedProductName(null);
            return;
        }
        setSelectedProductId(productVariationId);
        setSelectedProductName(name);
        await getBatchesByProductVariationId(productVariationId).then((res) => {
            reset();
            setValue('items', []);
            res.data?.data?.map((batch: any) => {
                append({
                    productVariationId: batch.product_variation_id,
                    purchaseItemId: batch.purchase_item_id,
                    quantity: 0,
                });
            });
        });
    };

    const options =
        data?.data?.map((product: any) => ({
            label: product.name,
            value: product.id,
        })) || [];

    return (
        <div className={'w-1/2'}>
            <AutoCompleteInput
                options={options}
                emptyMessage={'No products found'}
                isLoading={isLoading || isFetching}
                placeholder={'Select Product'}
                onInputChange={handleSearchTextChange}
                onValueChange={(value) =>
                    handleSelectedProductChange(value.value, value.label)
                }
            />
        </div>
    );
};

ProductSelector.displayName = 'ProductSelector';
